import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import {
  Services,
  Languages,
  AboutData,
  Industries,
  Services2,
} from "./config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faUser,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import tomedesLogo from "assets/images/Tomedes_Logo.svg";

export default function Header() {
  const [hamburger, setHamburger] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (hamburger) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [hamburger]);

  const listenToScroll = () => {
    let heightToHideFrom = 60;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const caretDownFil = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      class="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );
  const closeModalIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );

  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };
  const variant = useExperiment("_b1eORemTP6uefA63zaTlQ");
  // const variant = 1;

  const style = {
    background:
      "transparent linear-gradient(180deg, #000000 0%, #00173A 100%) 0% 0% no-repeat padding-box",
  };
  return (
    <>
      <div className="hidden lg:flex items-center justify-center w-full bg-black border-b border-quotetext-300">
        <div className="w-full max-w-screen-xl flex items-center justify-end py-2">
          <p className="flex flex-wrap font-opensans font-normal mr-8 text-13 leading-5 text-[#A5A5A5]">
            <a href="mailto:support@tomedes.com">support@tomedes.com</a>
            &nbsp;|&nbsp;
            <a href="tel:+19852390142">US: +1 985 239 0142</a>
            &nbsp;|&nbsp;
            <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
          </p>
          <Link
            to="/user/login"
            className="text-13 text-white font-opensans flex items-center justify-center ml-3 mr-2"
          >
            <FontAwesomeIcon
              icon={faUser}
              className="text-white w-[10px] mr-2"
            />
            ACCOUNT
          </Link>
          <div className="ml-2 font-opensans xs:font-secondary text-14 text-gray hover:text-orange flex justify-center items-center gap-2 relative group cursor-pointer">
            <img
              src="https://tomedes.gumlet.io/assets/images/usa.svg"
              alt="language"
              width="18"
              height="13"
            />{" "}
            <span>USA - EN</span> <span>{caretDownFil}</span>
            <div className="absolute top-0 z-[101] pt-[29px] hidden group-hover:block">
              <div className="usa_modal_body bg-white  pl-6 py-2 space-y-3 w-[234px] h-[250px] overflow-y-scroll">
                <a
                  hreflang="en-us"
                  href="https://www.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  English
                </a>
                <a
                  hreflang="es"
                  href="https://es.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Español
                </a>
                <a
                  hreflang="cn"
                  href="https://cn.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  简体中文
                </a>
                <a
                  hreflang="cn"
                  href="https://tw.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  中國傳統的
                </a>
                <a
                  hreflang="de"
                  href="https://de.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Deutsch
                </a>
                <a
                  hreflang="fr"
                  href="https://fr.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Français
                </a>
                <a
                  hreflang="nl"
                  href="https://nl.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Nederlands
                </a>
                <a
                  hreflang="he"
                  href="https://www.tomedes.co.il/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  עברית
                </a>
                <a
                  hreflang="ja"
                  href="https://jp.tomedes.com"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  日本語
                </a>
                <a
                  hreflang="ko"
                  href="https://kr.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  한국어
                </a>
                <a
                  hreflang="nb"
                  href="https://no.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Norsk
                </a>
                <a
                  hreflang="pl"
                  href="https://pl.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Polski
                </a>
                <a
                  hreflang="ro"
                  href="https://ro.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Româna
                </a>
                <a
                  hreflang="sv"
                  href="https://sv.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Svenska
                </a>
                <a
                  hreflang="tr"
                  href="https://tr.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Türk
                </a>
                <a
                  hreflang="ru"
                  href="https://ru.tomedes.com/"
                  target="_blank"
                  className="text-black hover:text-lightBlue block"
                >
                  Русский
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className={`header-wrapper sticky top-[-1px] left-0 right-0 z-[100] bg-black lg:flex lg:flex-col lg:items-center lg:justify-center px-4 ${
          hamburger ? "h-screen lg:h-auto overflow-y-scroll" : ""
        }`}
      >
        <div className="flex items-center justify-between lg:flex-row flex-col py-5 sm:py-6 sm:p-6 lg:p-0  max-w-screen-xl w-full">
          <div className="logo flex justify-between items-center w-full text-left">
            <Link to="/" className="hidden lg:block">
              <img
                src={tomedesLogo}
                alt="logo"
                className="w-[150px] md:w-[unset]"
              />
            </Link>
            {isVisible && (
              <Link to="/" className="lg:hidden">
                <img
                  src={tomedesLogo}
                  alt="logo"
                  className="w-[150px] md:w-[unset] h-8"
                />
              </Link>
            )}
            {!isVisible && (
              <Link
                to="/quote"
                className="uppercase rounded-full bg-orange hover:bg-newOrange-100 text-white cursor-pointer text-14 font-semibold py-1 px-4 text-center transition-all duration-300 lg:hidden h-8 flex items-center"
              >
                {variant == "1" ? "START TRANSLATION" : " Translate Now"}
              </Link>
            )}
            {hamburger ? (
              <div
                className="w-8 lg:hidden h-8 bg-white text-black text-center flex items-center justify-center text-xl rounded-full"
                onClick={() => setHamburger(!hamburger)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </div>
            ) : (
              <div
                className="lg:hidden flex flex-col items-center justify-center"
                onClick={() => setHamburger(!hamburger)}
              >
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 my-1.5 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
              </div>
            )}
          </div>
          <p className="font-normal text-12 leading-5 font-opensans xs:font-secondary text-[#A5A5A5] self-baseline pt-5 pr-3 lg:hidden">
            <a href="mailto:support@tomedes.com">support@tomedes.com</a>
            <span className="block">
              <a href="tel:+19852390142">US: +1 985 239 0142</a>
              &nbsp;|&nbsp;
              <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
            </span>
          </p>
          <section
            className={`${hamburger ? "block" : "hidden"} w-full lg:block`}
          >
            <nav className="lg:flex items-center justify-center relative">
              <ul
                className="nav font-normal flex lg:items-center font-opensans lg:flex-row flex-col text-white"
                style={{ WebkitTapHighlightColor: "transparent" }}
              >
                <li className="leading-[19px] pt-8 pb-3 lg:pt-0 lg:pb-0">
                  <Link
                    to="/"
                    className="lg:px-6 lg:py-3 p-3 mx-1 text-base hover:text-orange w-full cursor-pointer"
                  >
                    <span>Home</span>
                  </Link>
                </li>
                <li className="service_menu focus:outline-none leading-[19px] lg:px-6 lg:py-10 p-3 mx-1 text-base w-full inline-block group relative">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "services" ? false : "services"
                      )
                    }
                  >
                    Services
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "services"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={`${
                      activeMenu === "services" ? "block" : "hidden"
                    }  service_menu_child sm:w-[32rem] lg:absolute focus:outline-none left-0 lg:top-24 top-9  transition-all duration-500 pl-0 z-10 pt-5 pb-4`}
                    style={style}
                  >
                    {Services?.map(({ list, link, byline }, index) => (
                      <li className="px-[38px] sm:w-auto w-80 pb-[15px] hover:text-orange text-left text-base font-opensans xs:font-secondary font-normal">
                        <Link to={link} key={index}>
                          <div
                            className={`${
                              index == 1 || index == 0
                                ? "text-base md:text-xl md:font-semibold"
                                : " text-base md:text-lg"
                            }`}
                          >
                            {list}
                          </div>
                          <div className="text-12 md:text-13 mt-2 text-newgray mb-4">
                            {byline}
                          </div>
                        </Link>
                      </li>
                    ))}
                    <div className="bg-[#001533] pt-[14px]">
                      {Services2?.map(({ list, link, byline }, index) => (
                        <li className="px-[40px] w-auto sm:w-80 hover:text-orange text-left text-base  font-opensans xs:font-secondary bg-[#001533] font-normal">
                          <Link to={link} key={index}>
                            <div
                              className={`${
                                index == 1 || index == 0
                                  ? "text-base sm:text-lg py-[6px]"
                                  : " text-lg md:text-lg"
                              }`}
                            >
                              {list}
                            </div>
                            <div className="text-12 md:text-13 mt-2 text-newgray mb-4">
                              {byline}
                            </div>
                          </Link>
                        </li>
                      ))}
                    </div>
                  </ul>
                </li>
                <li className="languages_menu leading-[19px] w-full lg:px-6 lg:py-10 p-3 mx-1 text-base group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "languages" ? false : "languages"
                      )
                    }
                  >
                    Languages
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "languages"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "languages" ? "block" : "hidden"
                    } languages_menu_child w-full lg:w-6/12 left-[105px] top-24 place-content-center place-items-center z-10 grid-cols-1 lg:grid-cols-2 lg:absolute lg:py-4 py-8`}
                    style={style}
                  >
                    {Languages?.map(
                      ({ list, img_link, link, underline }, i) => (
                        <li
                          key={i}
                          className={`w-full ${underline ? "underline" : null}`}
                        >
                          <Link
                            to={link}
                            className={`hover:text-orange text-lg font-normal font-opensans pr-4 pl-8 py-1 flex items-center`}
                          >
                            {img_link ? (
                              <img
                                src={img_link}
                                className="mr-2"
                                alt="loading..."
                              />
                            ) : (
                              ""
                            )}
                            {list && list}
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                </li>
                <li className="languages_menu leading-[19px] w-full lg:px-6 lg:py-10 p-3 mx-1 text-base group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(
                        activeMenu === "industries" ? false : "industries"
                      )
                    }
                  >
                    <Link to="/industries">Industries</Link>
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "industries"
                          ? "rotate-180 text-orange"
                          : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      activeMenu === "industries" ? "block" : "hidden"
                    } languages_menu_child w-full lg:w-5/12 left-24 top-24 place-content-center place-items-center z-10 lg:absolute lg:pb-[10px] pb-8 lg:ml-[150px]`}
                    style={style}
                  >
                    {Industries?.map(({ data, link }, index) => (
                      <li
                        key={index}
                        className="hover:text-orange text-center text-lg font-normal font-opensans py-1"
                      >
                        <Link className="w-full" to={link}>
                          {data}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="leading-[19px] lg:px-6 w-full lg:py-10 p-3 mx-1 text-base group">
                  <span
                    className="flex justify-between items-center"
                    onClick={() =>
                      setActiveMenu(activeMenu === "about" ? false : "about")
                    }
                  >
                    About
                    <FontAwesomeIcon
                      className={`${
                        activeMenu === "about" ? "rotate-180 text-orange" : ""
                      } text-white lg:hidden text-2xl transition`}
                      icon={faAngleDown}
                    />
                  </span>
                  <div
                    className={`${
                      activeMenu === "about" ? "block" : "hidden"
                    } items-center justify-center top-24 p-10 pt-5 flex-col lg:absolute w-full md:w-[32rem] left-0 md:left-[175px] lg:hidden lg:group-hover:flex z-10`}
                    style={style}
                  >
                    <h3 className="font-opensans xs:font-secondary font-normal text-base text-white leading-8">
                      We are a{" "}
                      <a
                        href="/"
                        className="text-orange hover:text-newOrange-100 cursor-pointer"
                      >
                        translation company
                      </a>{" "}
                      committed to providing high-quality professional
                      translation services to businesses in the United States
                      and around the world.
                    </h3>
                    <Link
                      to="/about-tomedes"
                      className="inline-block underline text-white hover:text-orange text-base font-opensans font-normal w-full text-left leading-[22px] mt-6 mb-8 uppercase"
                    >
                      Who we are
                    </Link>
                    <ul className="text-lg font-normal font-opensans list-disc w-full text-left list-inside text-[#C9C9C9]">
                      {AboutData?.map(({ link, list }, index) => (
                        <li
                          className="leading-6 py-1.5 hover:text-orange hover:underline"
                          key={index}
                        >
                          <Link to={link}>{list}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li className="leading-[19px] p-3 lg:px-6 ml-1 mr-2">
                  <Link
                    to="/contactus.php"
                    className="text-base hover:text-orange cursor-pointer whitespace-nowrap lg:transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
              <Link
                to="/quote"
                className="hidden lg:inline-block leading-[1] uppercase font-opensans font-bold text-center rounded-full py-3 bg-orange hover:bg-newOrange-100 text-white text-sm cursor-pointer w-[153px] h-[40px]"
              >
                {variant == "1" ? "START TRANSLATION" : " Translate Now"}
              </Link>
              <div className="mt-10 lg:hidden flex flex-col gap-6 md:items-center">
                <Link
                  to="/quote"
                  className="block md:inline-block md:w-[450px] uppercase rounded-full bg-orange hover:bg-newOrange-100 font-opensans font-semibold text-gray cursor-pointer text-14 text-center py-5"
                >
                  {variant == "1" ? "START TRANSLATION" : " Translate Now"}
                </Link>
                <Link
                  to="/user/login"
                  className="block md:inline-block md:w-[450px] uppercase rounded-full border-2 border-white font-opensans font-semibold text-gray cursor-pointer text-14 text-center py-5"
                >
                  <FontAwesomeIcon
                    icon={faUser}
                    className="mr-2 text-white w-[10px]"
                  />
                  Account
                </Link>
              </div>
              <div
                className={`block lg:hidden ${showModal ? "hidden" : "block"}`}
              >
                <p
                  className="mt-8 font-opensans xs:font-secondary text-14 text-gray flex justify-center items-center gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal((showModal) => !showModal);
                    setActiveMenu(false);
                  }}
                >
                  <img
                    src="https://tomedes.gumlet.io/assets/images/usa.svg"
                    alt="languages"
                  />{" "}
                  <span>USA - EN</span> <span>{caretDownFil}</span>
                </p>
              </div>
            </nav>
          </section>
        </div>
        {showModal && (
          <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 z-[101] grid place-items-center bg-black opacity-[95%]">
            <div className="usa_modal h-[300px] w-[300px] overflow-scroll">
              <div className="usa_modal_head bg-midBlue pl-6 pr-3 font-opensans xs:font-secondary text-14 text-gray flex justify-between items-center gap-2">
                <p className="flex items-center gap-4 cursor-pointer">
                  <img
                    src="https://tomedes.gumlet.io/assets/images/usa.svg"
                    alt="languages"
                  />{" "}
                  <span className="text-orange">USA - EN</span>
                </p>
                <span
                  className="cursor-pointer"
                  onClick={() => setShowModal((showModal) => !showModal)}
                >
                  {closeModalIcon}
                </span>
              </div>
              <div className="usa_modal_body bg-[#000D21] text-gray pl-6 py-2 space-y-3">
                <a
                  hreflang="en-us"
                  href="https://www.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  English
                </a>
                <a
                  hreflang="es"
                  href="https://es.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Español
                </a>
                <a
                  hreflang="cn"
                  href="https://cn.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  简体中文
                </a>
                <a
                  hreflang="cn"
                  href="https://tw.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  中國傳統的
                </a>
                <a
                  hreflang="de"
                  href="https://de.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Deutsch
                </a>
                <a
                  hreflang="fr"
                  href="https://fr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Français
                </a>
                <a
                  hreflang="nl"
                  href="https://nl.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Nederlands
                </a>
                <a
                  hreflang="he"
                  href="https://www.tomedes.co.il/"
                  target="_blank"
                  className="block"
                >
                  עברית
                </a>
                <a
                  hreflang="ja"
                  href="https://jp.tomedes.com"
                  target="_blank"
                  className="block"
                >
                  日本語
                </a>
                <a
                  hreflang="ko"
                  href="https://kr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  한국어
                </a>
                <a
                  hreflang="nb"
                  href="https://no.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Norsk
                </a>
                <a
                  hreflang="pl"
                  href="https://pl.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Polski
                </a>
                <a
                  hreflang="ro"
                  href="https://ro.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Româna
                </a>
                <a
                  hreflang="sv"
                  href="https://sv.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Svenska
                </a>
                <a
                  hreflang="tr"
                  href="https://tr.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Türk
                </a>
                <a
                  hreflang="ru"
                  href="https://ru.tomedes.com/"
                  target="_blank"
                  className="block"
                >
                  Русский
                </a>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
